import React from 'react';

var SvgGlobeEuFilledIcon = function SvgGlobeEuFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-2.53 11.884a5.477 5.477 0 0 0 2.53.616 5.481 5.481 0 0 0 3.796-1.52l-2.127.399a1.876 1.876 0 0 1-1.34-.253 1.917 1.917 0 0 0-2.371.27l-.489.488Zm7.745-6.636a5.517 5.517 0 0 0-3.018-3.292l-1.904.858a.922.922 0 0 0-.543.841c0 .612-.392 1.156-.973 1.35l-.75.25a1.537 1.537 0 0 0-1.03 1.71l.06.353a1.115 1.115 0 0 0 2.097.316l.122-.246a2.059 2.059 0 0 1 1.842-1.138h.507c.69 0 1.25.56 1.25 1.25v.375c0 .207.168.375.375.375a1 1 0 0 0 1-1v-.771c0-.543.347-1.025.862-1.197l.103-.034Z"
  }));
};
SvgGlobeEuFilledIcon.displayName = "GlobeEuFilledIcon";

export { SvgGlobeEuFilledIcon as S };
